// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2bIas","empty":"ModalGraph_empty__2bG7j"};